export const REGEX_ORMA_URL = /^((https:\/\/)?support((\w*)?).garmin.com)(\/[a-z][a-z]-[A-Z][A-Z])?\/exchange((\/)|\?|$)/gm;
export const REGEX_010_PN_ONLY = /^(010-).*/g;